import axios from 'axios';

export async function createCardToken({
    number,
    holder_name,
    exp_month,
    exp_year,
    cvv,
}: {
    number: string;
    holder_name: string;
    exp_month: string;
    exp_year: string;
    cvv: string;
}) {


    try {
        const publicKey = 'pk_l3dq2xlsoacKmYR5'; // ex: "ak_test_xxxxx"

        const response = await axios.post(
            `https://api.pagar.me/core/v5/tokens?appId=${publicKey}`,
            {
                card: {
                    number,
                    holder_name,
                    exp_month,
                    exp_year,
                    cvv,
                }
            },
            {
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        );

        return { status: 'success', response: response.data.id }; // Token do cartão
    } catch (error: any) {
        return { status: 'error', response: 'Erro ao validar cartão' };
    }
}